/* tslint:disable */

/**
 */
export class EstimationHeadBalanceResult {
    tfp?: number;
    id?: number;
    equipName?: string;
    tr?: number;
    ts?: number;
    vc?: number;
    vep?: number;
    specificSize?: string;
    dhp?: number;
    conso?: number;
    toc?: string;
    tocMax?: string;
    precision?: number;
    background?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/estimation-head-balance-result.ts